export type ReleaseNote = {
  id: string;
  title: string;
  date: string;
  summary: string;
  details: string;
};

export const releaseNotes: ReleaseNote[] = [
  {
    id: "20250627",
    title: "1.02v 패치노트",
    date: "2025-06-27",
    summary: "레이드 데이터 최신화, 페이지 추가",
    details: `
■ 제작 계산기 페이지
- 아비도스 융화 재료 제작 계산기 추가

■ 주간 레이드 계산기
- 귀속 골드 데이터 추가
- 귀속 골드 표기
    `,
  },
  {
    id: "20250604",
    title: "1.01v 패치노트",
    date: "2025-06-04",
    summary: "보석 깐부 시스템 전면 개편, 팔찌 UI 개선",
    details: `
■ 보석 깐부 페이지
- 부캐릭터를 여러 캐릭 입력해서 매칭 조건을 늘릴 수 있게 수정

■ 팔찌 시뮬레이터
- 팔찌 로그 개선

■ 기타
- 사이트 UI 개선
    `,
  },
  {
    id: "20250528",
    title: "사이트 페이지 설명서",
    date: "2025-05-28",
    summary: "사이트 이용 전 읽으면 도움이 돼요!",
    details: `
■ 메인 화면
- 캐릭터명 입력 시 주간 레이드 계산기로 이동
- 중앙 검색바 및 릴리즈 노트 확인 기능 제공

■ 주간 레이드 계산기
- 유각/강화비 등 입력 추가 소비, 획득 골드를 입력 해 주간 골드 계산 가능
- 부계정 탭 분리
- 레이드 클릭 1회=클리어, 2회=더보기 골드 및 재료 획득
- 재료 보기 기능 및 골드 보기 탭 지원

■ 보석 깐부 매칭
- 본/부캐 입력 → 상대 자동 매칭
- 조건 일치 시 매칭 카드 UI 제공

■ 팔찌 시뮬레이터
- 확률표 기반 뽑기 기능
- 전체 사용자 로그 기록 해 공식 확률과 실제 결과 비교 가능

■ 패키지 계산기
- 패키지 가치 자동 계산
- API를 이용해 실시간 시세 반영

■ 경매 계산기
- 경매 상품을 얼마로 입찰새야 최대 이득을 볼 수 있는지 계산

※ 일부 버그는 추후 수정 예정입니다.
    `,
  },
];
